import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonService } from '../_services';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-dashboard-v2',
  templateUrl: './dashboard-v2.component.html',
  styleUrls: ['./dashboard-v2.component.css']
})
export class DashboardV2Component implements OnInit {
  route: string;
  cardDetail: any = {};
  totalSTP = 0;
  meetingSTP = 0;
  exceedSTP = 0;
  closeSTP = 0;
  waterSTP = 0;
  totalCETP = 0;
  meetingCETP = 0;
  exceedCETP = 0;
  closeCETP = 0;
  waterCETP = 0;
  userName = null;
  userLevel = null;
  vendor_id = 0;
  public state: string = environment.state;
  public stateCode: string = environment.stateCode;

  graphPlot = false;

  stpPieChart: Chart;
  cetpPieChart: Chart;

  constructor(private _service: CommonService) {}

  ngOnInit(): void {
    this.getAllIndustryCardDetails();
    this.getAllIndustryCardExceedanceDetails();
  }

  getAllIndustryCardDetails() {
    this.route = 'get-dashboard-v2-card-details';
    const token = localStorage.getItem('userToken');
    const data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status === 200) {
        const d = response.data;
        this.totalSTP = d.total_djb_stp ?? 0;
        this.closeSTP = d.close_djb_stp ?? 0;
        this.totalCETP = d.total_djb_cetp ?? 0;
        this.closeCETP = d.close_djb_cetp ?? 0;
      }
      this.setMeetingAndExceedance();
    });
  }

  getAllIndustryCardExceedanceDetails() {
    this.route = 'get-public-industry-card-djb-exceedance-details';
    const token = localStorage.getItem('userToken');
    const data: any = {
      user_id: this.userName,
      user_level: this.userLevel
    };

    if (this.userLevel === 'vendor') {
      data.vendor_id = this.vendor_id;
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status === 200) {
        const ex = response.exceedance_summary;
        this.exceedSTP = ex.exceedance_djb_stp ?? 0;
        this.exceedCETP = ex.exceedance_djb_cetp ?? 0;
        this.waterCETP = response.cetp_total_flow_litres;
        this.waterSTP = response.stp_total_flow_litres;
      }
      this.setMeetingAndExceedance();
    });
  }

  setMeetingAndExceedance() {
    this.meetingSTP = Math.max(this.totalSTP - this.exceedSTP, 0);
    this.meetingCETP = Math.max(this.totalCETP - this.exceedCETP, 0);

    if (this.totalSTP + this.totalCETP > 0) {
      this.graphPlot = true;
      this.drawPieChart();
    }
  }

  drawPieChart() {
    // Prepare STP data
    const stpData = [
      { name: 'Meeting Standards', y: this.meetingSTP, color: '#119DF3' },
      { name: 'Not Meeting Standards', y: this.exceedSTP, color: '#FB6058' },
      { name: 'CEMS Offline', y: this.closeSTP, color: '#814EC1' },
    ];

    // Prepare CETP data
    const cetpData = [
      { name: 'Meeting Standards', y: this.meetingCETP, color: '#119DF3' },
      { name: 'Not Meeting Standards', y: this.exceedCETP, color: '#FB6058' },
      { name: 'CEMS Offline', y: this.closeCETP, color: '#814EC1' },
    ];

    this.stpPieChart = new Chart({
      chart: {
        type: 'pie',
      },
      credits: { enabled: false },
      title: { text: '' },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          }
        }
      },
      series: [{
        name: 'STP',
        type: 'pie',
        data: stpData
      }]
    });

    this.cetpPieChart = new Chart({
      chart: {
        type: 'pie',
      },
      credits: { enabled: false },
      title: { text: '' },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          }
        }
      },
      series: [{
        name: 'CETP',
        type: 'pie',
        data: cetpData
      }]
    });
  }
}
